export const renderPullQuote = (props) => {
	const {
		alignment,
		name,
		image,
		altText,
		jobTitle,
		quote,
		isNested = true,
		hideTopPadding = false,
		hideBottomPadding = false,
		authorNameLink,
		authorLinkOpeningMode,
		cta = {},
	} = props;
	const { label = '', url = '', mode, ariaLabel } = cta;

	const css = `ds-pull-quote ${isNested ? '' : 'container-fluid'}`;

	return `<ds-pull-quote
				class="${css}"
				name="${name}"
				alignment="${alignment}"
				image="${image}"
				alt-text="${altText}"
				job-title="${jobTitle}"
				quote="${quote}"
				is-nested="${isNested}"
				hide-top-padding="${hideTopPadding}"
				hide-bottom-padding="${hideBottomPadding}"
				author-name-link="${authorNameLink}"
				author-link-opening-mode="${authorLinkOpeningMode}"
				cta-label="${label}" cta-url="${url}"
				cta-mode="${mode}"
				cta-aria-label="${ariaLabel}"
				data-link-event="">
			</ds-pull-quote>`;
};
